module.exports = __webpack_public_path__ + "static/media/farmindia_img_3.35d89b34.png";